var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"material-icons pointer",on:{"click":function($event){return _vm.emailTask(_vm.task)}}},[_vm._v("email")])])}
var staticRenderFns = []
export { render, staticRenderFns }